export class ToggleDarkMode {
  static readonly type = '[UI] Toggle DarkMode';
  constructor(public isDarkMode: boolean) {}
}

export class SetLanguage {
  static readonly type = '[UI] Set Language';
  constructor(public language: string) {}
}

export class ToggleToolbar {
  static readonly type = '[UI] Toggle Toolbar';
  constructor(public isToolbarCollapsed: boolean) {}
}

export class LoadWorkRestUiPreferences {
  static readonly type = '[UI] Load Work Rest UI Preferences';
}

export class SetDailyCrewColoringPreference {
  static readonly type = '[UI] Set Daily Crew Coloring Preference';
  constructor(public enabled: boolean) {}
}

export class SetMatrixColoringPreference {
  static readonly type = '[UI] Set Matrix Coloring Preference';
  constructor(public enabled: boolean) {}
}
